<template>
  <div style="margin-left: -45px">
    <div>
      <h3 style="margin-top: 8px; font-size: 16px;">Loyalty Card Types</h3>
      <base-input alternative="" label="Apply Bonanza to these Supercard Types" input-classes="form-control" style="margin-top: 8px; margin-left: 45px;">
        <b-row>
          <b-col>
            <a-select
                v-model="menus.selectedCardTypes"
                mode="tags"
                style="width: 100%"
                placeholder="Select Loyalty Card Types"
                optionFilterProp="children"
            >
              <a-select-option v-for="loyaltyCardType in loyaltyCardTypeList"
                               :key="loyaltyCardType"
                               :value="loyaltyCardType">{{ loyaltyCardType }}
              </a-select-option>
            </a-select>
          </b-col>
          <b-col></b-col>
          <b-col></b-col>
        </b-row>
      </base-input>
    </div>
  </div>

</template>

<script>

let component_x;
export default {
  mounted: async function () {
    component_x = this;

    if(this.$attrs.defaultValue != undefined || this.$attrs.defaultValue != null){
      this.menus = this.$attrs.defaultValue
      this.isNewSetting = false
    }
    this.settingCode = this.$attrs.settingCode
  },
  watch: {
    menus: {
      handler: async function(){
        var configValues = {}
        configValues[this.settingCode] = this.menus
        component_x.$emit("changeValue", configValues)
      },
      deep: true
    }
  },
  data() {
    return {
      loyaltyCardTypeList: [
          "Gold",
          "Classic",
          "Junior"
      ],
      selectedCardTypes: [],
      menus: {},
      settingCode: null,
    }
  },
}
</script>
